/**
 * 行业解决方案页面翻译 - 中文
 * Industry Solutions page translations - Chinese
 */

export default {
  hero: {
    title: '行业解决方案',
    subtitle: '深耕金融、制造、零售、专业服务、医疗与政府等行业，提供更贴近业务场景的数字化与智能化解决方案',
    imageAlt: '行业解决方案背景图'
  },
  
  overview: {
    title: '产品概览'
  },
  
  industries: {
    finance: {
      title: '金融行业解决方案',
      imageAlt: '金融行业解决方案',
      painPoints: {
        title: '需求痛点',
        content: '网络安全威胁、严格的合规要求、传统系统陈旧、客户体验期望持续提升'
      },
      solution: {
        title: '解决方案',
        content: '围绕金融云、统一监管报送、托管安全服务与全渠道客户平台，构建安全、合规、敏捷的数字化金融底座'
      },
      results: {
        title: '实施效果',
        content: '支撑核心系统现代化与监管报送自动化，缩短业务上线周期并提升客户服务一致性'
      }
    },
    
    ticketAi: {
      title: '智能工单与AI分析平台',
      imageAlt: '智能工单与AI分析平台',
      ticketSystem: {
        title: '智能工单系统',
        features: [
          '自动化工单创建、分配与优先级排序',
          '多渠道接入（邮件、电话、聊天、API）',
          'SLA管理与实时监控仪表盘',
          '自定义工作流与业务规则引擎',
          '知识库集成与自动回复建议'
        ]
      },
      aiAnalytics: {
        title: 'AI智能分析与数据集成',
        features: [
          '自然语言处理技术解析工单内容',
          '预测性分析识别潜在问题与趋势',
          '多源数据整合与可视化报表',
          '自定义KPI监控与异常警报',
          '开放API与第三方系统无缝集成'
        ]
      },
      results: {
        title: '实施效果',
        content: '工单处理效率提升65%，人工错误减少40%，客户满意度提高35%，运营成本降低28%'
      }
    },
    
    manufacturing: {
      title: '制造行业解决方案',
      imageAlt: '制造行业解决方案',
      painPoints: {
        title: '需求痛点',
        content: '供应链中断、生产效率低下、设备停机、质量波动与数据孤岛并存'
      },
      solution: {
        title: '解决方案',
        content: '以工业物联网、MES/ERP 集成、数字化供应链看板与车间数字孪生为核心，打造智能工厂与数字化供应链'
      },
      results: {
        title: '实施效果',
        content: '提升生产透明度与质量追溯能力，降低停机风险并增强供应链协同效率'
      }
    },

    retail: {
      title: '零售行业解决方案',
      imageAlt: '零售行业解决方案',
      painPoints: {
        title: '需求痛点',
        content: '多国家、多门店服务请求分散，门店网络、POS 与终端故障影响营业，本地响应能力和开店搬迁流程难以统一'
      },
      solution: {
        title: '解决方案',
        content: '提供覆盖亚太地区的门店 IT 支持，建立统一服务台、本地工程师网络、门店 IT 全生命周期管理和标准化数据化运营机制'
      },
      results: {
        title: '实施效果',
        content: '集中管理数百家门店需求，提升响应速度与服务可控性，形成稳定、高效、可追踪的门店 IT 运营体系'
      }
    },
    
    healthcare: {
      title: '医疗行业解决方案',
      imageAlt: '医疗行业解决方案',
      painPoints: {
        title: '需求痛点',
        content: '医疗数据隐私保护、跨机构数据共享困难、远程医疗系统稳定性要求'
      },
      solution: {
        title: '解决方案',
        content: '安全可控的医疗数据存储与交换平台，符合隐私保护法规的系统架构'
      },
      results: {
        title: '实施效果',
        content: '数据交换效率提升60%，患者信息安全合规率100%，远程诊疗系统稳定性达99.9%'
      }
    },
    
    government: {
      title: '政府与公共事业解决方案',
      imageAlt: '政府与公共事业解决方案',
      painPoints: {
        title: '需求痛点',
        content: '电子政务系统稳定性要求高、数据安全防护需求严格、跨部门协作效率低'
      },
      solution: {
        title: '解决方案',
        content: '高可靠IT基础设施与安全防护体系，支持多部门数据共享与业务协同'
      },
      results: {
        title: '实施效果',
        content: '系统故障率降低45%，跨部门业务处理效率提升50%，数据安全合规率100%'
      }
    }
  },

  focusIndustries: {
    title: '按行业划分的解决方案',
    subtitle: '围绕金融、制造、零售、医疗、政府与智能工单 AI 六类核心场景，梳理更贴近客户需求的行业方案，便于官网直接展示能力边界与交付方向。',
    keySolutionLabel: '核心解决方案',
    painPointsTitle: '行业痛点',
    solutionTitle: '方案组成',
    outcomeTitle: '交付价值',
    items: [
      {
        title: '制造业',
        keySolution: '智能工厂与数字化供应链',
        painPoints: '供应链中断、生产效率低下、设备停机、质量波动、数据孤岛。',
        solutions: [
          '工业物联网平台：通过传感器连接机床和生产线，实现设备数据实时采集、预测性维护和能源管理，减少意外停机。',
          '制造执行系统集成：集成 MES 与 ERP 系统，实现从订单到成品的生产流程数字化、透明化，提高生产效率和质量追溯能力。',
          '数字化供应链看板：构建统一的供应链数据平台，实现供应商管理、库存优化和物流追踪的端到端可视化。',
          '车间数字孪生：创建生产线的虚拟模型，用于模拟优化、工艺调试和员工培训。'
        ],
        outcome: '通过设备互联、流程协同和供应链可视化，帮助制造企业降低非计划停机，提升质量追溯与跨基地协同能力。'
      },
      {
        title: '金融服务业',
        keySolution: '安全、合规与数字化客户体验',
        painPoints: '网络安全威胁、严格的合规要求、传统系统陈旧、客户体验期望高。',
        solutions: [
          '金融云与核心系统现代化：协助将核心业务系统安全迁移至金融云，提升系统弹性、灵活性和开发速度。',
          '统一监管报送平台：构建自动化平台，整合数据以满足人民银行、银保监会等的合规与报送要求。',
          '网络安全托管服务：提供 7x24 小时安全监控、威胁情报和应急响应，保护客户数据和交易安全。',
          '全渠道银行平台：集成手机银行、网上银行和线下网点系统，提供无缝、一致的个性化客户体验。'
        ],
        outcome: '以云化、合规自动化和托管安全为底座，支撑金融机构提升运营韧性、审计可追溯性和多渠道服务一致性。'
      },
      {
        title: '零售行业',
        keySolution: '多国家门店 IT 运维解决方案',
        painPoints: '多国家门店数量多、问题入口分散、设备与网络故障影响营业、开店搬迁关闭缺少标准化流程、本地响应能力不一致。',
        solutions: [
          '统一服务台：集中接收、分派和跟踪所有门店 IT 需求，统一管理 SLA、升级路径与处理闭环。',
          '本地工程师网络：覆盖亚太重点地区，结合远程诊断与现场支持，快速响应门店网络、POS、终端和外设问题。',
          '门店 IT 全生命周期管理：覆盖新店开业、日常运维、门店搬迁、升级改造与闭店回收，形成标准化交付清单。',
          '标准化流程与数据化管理：沉淀门店资产、服务记录、故障类型和响应数据，支撑运营看板与持续优化。'
        ],
        outcome: '帮助零售企业高效管理数百家门店，实现门店 IT 稳定、高效、可控的运营体系，减少营业影响并提升服务一致性。'
      },
      {
        title: '医疗行业',
        keySolution: '安全合规的医疗数据存储与交换平台',
        painPoints: '医疗数据隐私保护要求高，跨机构数据共享困难，远程医疗系统对稳定性和连续性要求严格。',
        solutions: [
          '医疗数据存储与交换平台：建设安全可控的数据交换通道，支持跨机构协作和信息共享。',
          '隐私保护与权限体系：基于角色、机构和业务场景设计访问控制、审计追踪与数据脱敏机制。',
          '远程医疗稳定性保障：围绕网络、终端、应用和监控体系提升远程诊疗系统可用性。',
          '合规架构设计：结合医疗数据保护要求，规划符合隐私法规的系统架构和运维流程。'
        ],
        outcome: '提升医疗数据交换效率和远程诊疗稳定性，保障患者信息安全与合规管理，支撑跨机构协同服务。'
      },
      {
        title: '政府与公共事业',
        keySolution: '高可靠 IT 基础设施与安全防护体系',
        painPoints: '电子政务系统稳定性要求高，数据安全防护严格，跨部门数据共享和业务协作效率不足。',
        solutions: [
          '高可靠基础设施：建设稳定的计算、网络、存储与灾备能力，支撑关键政务系统连续运行。',
          '数据安全防护体系：覆盖身份认证、访问控制、安全监测、日志审计和应急响应。',
          '跨部门数据共享平台：统一数据标准、接口规范和共享流程，支撑多部门业务协同。',
          '运维与合规管理机制：建立巡检、监控、故障响应和安全合规闭环，降低系统故障和治理风险。'
        ],
        outcome: '降低系统故障率，提升跨部门业务处理效率和数据安全合规水平，支撑公共服务稳定运行。'
      },
      {
        title: '智能工单与 AI 分析',
        keySolution: '自动化服务管理与智能运营分析平台',
        painPoints: '服务请求渠道分散、人工分派效率低、SLA 难以实时监控，缺少趋势预警和多源数据分析能力。',
        solutions: [
          '智能工单系统：支持自动化工单创建、分配、优先级排序、多渠道接入、SLA 管理和自定义工作流。',
          '知识库与自动回复建议：将 FAQ、SOP 和历史工单经验接入处理流程，提高一线响应效率。',
          'AI 智能分析：通过自然语言处理解析工单内容，结合预测性分析识别潜在问题、趋势和异常。',
          '数据集成与可视化：整合多源数据，提供自定义 KPI、异常警报、开放 API 和第三方系统集成能力。'
        ],
        outcome: '提升工单处理效率，减少人工错误，提高客户满意度并降低运营成本，让服务管理更可视、更可控。'
      }
    ]
  },

  productMatrix: {
    title: '更多产品与数字化能力',
    subtitle: '除智能工单与 AI 分析平台外，我们还可根据企业经营、营销、服务和内部协同场景，补充构建 CRM、营销自动化、小程序、AI 知识库与办公智能体能力。',
    modulesTitle: '核心模块',
    scenariosTitle: '适用场景',
    noteTitle: '支持组合式规划与分阶段落地',
    note: '以上产品能力可独立实施，也可与官网、CRM、ERP、工单系统、邮件和企业内部流程打通。我们会结合现有系统、组织分工和业务流程，制定更适合实际使用的交付方案。',
    action: '联系咨询方案',
    items: [
      {
        title: 'CRM软件开发',
        tagline: '会员体系与C端用户运营',
        description: '围绕品牌方的 C 端用户管理场景，进行会员 CRM 定制开发，覆盖用户档案、标签分层、积分成长、优惠券权益、互动触达与复购分析。',
        modules: [
          '会员档案、标签与分层体系',
          '积分、优惠券、等级与权益管理',
          '用户行为分析与复购运营能力'
        ],
        scenarios: [
          '品牌会员运营',
          'C端用户精细化触达',
          '活动增长与复购提升'
        ]
      },
      {
        title: 'MA营销自动化',
        tagline: '自动触达与转化增长',
        description: '打通官网表单、CRM、邮件、短信与企业 IM，构建线索评分、自动分层、营销旅程与转化归因闭环。',
        modules: [
          '线索评分与标签体系',
          '自动化旅程与消息触发',
          '活动效果归因与转化分析'
        ],
        scenarios: [
          '官网获客培育',
          '展会活动跟进',
          '会员唤醒与复购运营'
        ]
      },
      {
        title: '小程序',
        tagline: '轻量服务入口',
        description: '面向客户服务、会员运营、预约提交、工单查询和业务办理场景，提供小程序定制开发与后台集成。',
        modules: [
          '登录、会员与组织权限',
          '表单、工单与消息中心',
          'CRM、ERP、支付与 API 集成'
        ],
        scenarios: [
          '客户服务入口',
          '内部报修与审批',
          '会员服务与预约办理'
        ]
      },
      {
        title: 'AI知识库',
        tagline: '知识沉淀与智能问答',
        description: '整合 FAQ、SOP、工单经验、产品资料与内部文档，支持权限控制、多语言检索和问答式知识服务。',
        modules: [
          '文档接入与版本管理',
          '语义检索与问答生成',
          '权限控制与反馈闭环'
        ],
        scenarios: [
          '客服知识支持',
          '内部运维知识管理',
          '区域培训与经验复用'
        ]
      },
      {
        title: '办公智能体',
        tagline: '办公流程自动化',
        description: '面向邮件、审批、会议纪要、任务分发、日报周报、知识查询等办公场景，构建可接入企业系统的智能体能力。',
        modules: [
          '邮件、IM、日历与文档接入',
          '流程触发与任务编排',
          '数据回写、日志审计与权限控制'
        ],
        scenarios: [
          '销售跟进自动化',
          '服务运营协同',
          '管理例会与知识问答'
        ]
      }
    ]
  },
  
  coreFeatures: {
    title: '核心功能特点',
    
    ticketManagement: {
      title: '智能工单管理',
      description: '全生命周期工单跟踪，从创建到解决的完整流程管理，支持自定义字段和状态。自动分类与优先级排序，提升工单处理效率高达65%。',
      benefits: [
        '自动化路由',
        'SLA计时器',
        '批量操作',
        '团队协作'
      ]
    },
    
    dataAnalytics: {
      title: '实时数据分析',
      description: '直观的数据可视化仪表盘，实时监控关键绩效指标，帮助团队快速做出决策。通过多维度数据展示，异常识别速度提升40%。',
      benefits: [
        '自定义报表',
        '趋势分析',
        '部门对比',
        '导出功能'
      ]
    },
    
    aiAssistant: {
      title: 'AI智能助手',
      description: '基于机器学习的智能分析引擎，自动识别问题模式并提供解决方案建议。通过自然语言处理技术，工单自动分类准确率达92%。',
      benefits: [
        '自动分类',
        '优先级预测',
        '解决方案推荐',
        '情感分析'
      ]
    },
    
    dataIntegration: {
      title: '数据集成能力',
      description: '无缝对接企业现有系统，实现数据双向流动，消除信息孤岛。支持超过200种API集成，数据同步延迟低于100ms。',
      benefits: [
        'API接口',
        '第三方集成',
        '数据同步',
        '安全认证'
      ]
    }
  },
  
  cta: {
    title: '为您的行业定制智能解决方案',
    description: '我们的智能工单系统与AI分析平台已成功应用于金融、制造、医疗等多个行业，帮助企业提升运营效率、降低成本并做出数据驱动决策。联系我们，获取专属咨询服务',
    button: '获取行业专属方案'
  }
}
